import "core-js/modules/es7.array.includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "vertical-menu-item",
  props: ["arr", "isCollapse", 'showIcon', 'idx'],
  methods: {
    goItem: function goItem(router) {
      this.$emit('confirm', true);
      if (router === "carManagement" || router === "specialEquipmentManage" || router === "bidModel" || router === "vehicleNetApp") {
        this.$router.push("/main/" + router);
      }
    },
    itemChick: function itemChick(item) {
      var hiddenRoutes = ['dataScreening', 'international/dataScreening'];
      var isShowTop = !hiddenRoutes.includes(item.router);
      this.$emit('confirm', isShowTop);
    }
  }
};